<template>
  <div class="form-check form-switch form-check-custom form-check-solid" :class="{' d-flex flex-row-reverse justify-content-between align-items-center mb-0': between, ' mb-5': !between}">
    <label v-if="left" :for="id" :class="['form-check-label fs-6 fw-bolder text-black me-3', {isRequired: 'required'}]">
      <i v-if="icon" :class="icon"></i>
      <img v-if="img" :src="img" :class="imgClass"/>
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
    </label>
      <input v-show="!isLoading" class="form-check-input" type="checkbox"
          v-model="modelValue"
          :disabled="disabled || isLoading"
          :id="id"/>
      <span v-show="isLoading" class="spinner-border spinner-border-sm align-middle me-2"></span>
      <label v-if="!left" :for="id" :class="['form-check-label fs-6 fw-bolder text-black', {isRequired: 'required'}]">
        <i v-if="icon" :class="icon"></i>
        <img v-if="img" :src="img" :class="imgClass"/>
        {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
      </label>
  </div>
</template>

<script setup>

import { defineProps, defineModel } from 'vue';

const modelValue = defineModel({ type: Boolean, required: true });
const props = defineProps({
  label: String,
  disabled: Boolean,
  isRequired: Boolean,
  id: String,
  icon: {type: String, default: ''},
  img: {type: String, default: ''},
  imgClass: {type: String, default: ''},
  between: {type:Boolean, default: false},
  left: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false }
});


</script>
<style scoped>
input.invalid {
  border: 1px solid red;
}
</style>
